<template>
  <div id="base-dropdown">
    <label :class="labelClassNames">{{ labelValue }}</label>
    <select v-model="selected" class="form-control selection" @change="inputSelected($event)">
      <option
        v-for="(option,index) in list"
        :key="index"
				:style="{background: option.value}"
        v-bind:value="option.value"
      >{{ option.text }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "BaseDropDown",
  props: {
    list: {
      type: Array,
      required: true
    },
    defaultValue: {
      type: [Number,String],
      required: false
    },
    labelClassNames: {
      type: String,
      default: ""
    },
    labelValue: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      selected: this.defaultValue
    };
  },
  computed: {},
  created() {
		this.selected = this.defaultValue;
  },
  methods: {
    inputSelected(e) {
      this.$emit("input", this.selected);
    }
  },
  watch: {
    defaultValue(newValue, oldValue) {
      this.selected = newValue;
    }
  }
};
</script>

<style lang="scss">
.selection {
  margin-bottom: 1em;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/inputs/ColorDropdown.vue